import { getPermissionData } from "containers/Auth/permissions";

export const actions = {
    START_SIGN_IN: "START_SIGN_IN",
    SIGN_IN_SUCCESSFUL: "SIGN_IN_SUCCESSFUL",
    SIGN_IN_FAILED: "SIGN_IN_FAILED",

    START_SIGN_OUT: "START_SIGN_OUT",
    SIGN_OUT_SUCCESSFUL: "SIGN_OUT_SUCCESSFUL",

    STORE_USER_DATA: "STORE_USER_DATA",
    STORE_TOKEN: "STORE_TOKEN",

    START_INVITE_USER: "START_INVITE_USER",
    INVITE_USER_SUCCESSFUL: "INVITE_USER_SUCCESSFUL",
    INVITE_USER_FAILED: "INVITE_USER_FAILED",

    START_ACTIVATE_ACCOUNT: "START_ACTIVATE_ACCOUNT",
    ACTIVATE_ACCOUNT_SUCCESSFUL: "ACTIVATE_ACCOUNT_SUCCESSFUL",
    ACTIVATE_ACCOUNT_FAILED: "ACTIVATE_ACCOUNT_FAILED",

    START_FORGOT_PASSWORD: "START_FORGOT_PASSWORD",
    FORGOT_PASSWORD_SUCCESSFUL: "FORGOT_PASSWORD_SUCCESSFUL",
    FORGOT_PASSWORD_FAILED: "FORGOT_PASSWORD_FAILED",

    START_RESEND_EMAIL_RESET_PASSWORD: "START_RESEND_EMAIL_RESET_PASSWORD",
    RESEND_EMAIL_RESET_PASSWORD_SUCCESSFUL: "RESEND_EMAIL_RESET_PASSWORD_SUCCESSFUL",
    RESEND_EMAIL_RESET_PASSWORD_FAILED: "RESEND_EMAIL_RESET_PASSWORD_FAILED",

    START_RESET_PASSWORD: "START_RESET_PASSWORD",
    RESET_PASSWORD_SUCCESSFUL: "RESET_PASSWORD_SUCCESSFUL",
    RESET_PASSWORD_FAILED: "RESET_PASSWORD_FAILED",

    UPDATE_USER_ICON: "UPDATE_USER_ICON",

    STORE_USER_PERMISSIONS: "STORE_USER_PERMISSIONS",

    REDIRECT_TO_WORKSPACE: "REDIRECT_TO_WORKSPACE",

    STORE_UI_COUNT_DATA: "STORE_UI_COUNT_DATA",

    STORE_BACKEND_VERSION: "STORE_BACKEND_VERSION",

    STORE_AUTH_CHECK_PUBLIC_INFO: "STORE_AUTH_CHECK_PUBLIC_INFO",
};

export const initialState = {
    token: "",
    user: null,
    isSignedIn: null,
    userPermissionList: [],
    userPermissionData: {},
    canRedirectToWorkspace: true,
    uiCountMax: 0,
    uiCount: 0,
    backendVersion: null,
    authCheckPublicInfo: {
        workspaceName: null,
        workspaceHighlightColor: null,
        backendVersion: null,
        frontendVersion: null,
    },
};

export default (state = initialState, { type, response }) => {
    switch (type) {
        case actions.START_SIGN_IN: {
            return {
                ...state,
            };
        }
        case actions.STORE_TOKEN: {
            return {
                ...state,
                token: response,
            };
        }
        case actions.SIGN_IN_SUCCESSFUL: {
            return {
                ...state,
                isSignedIn: true,
            };
        }
        case actions.SIGN_IN_FAILED: {
            return {
                ...state,
                token: "",
                user: {},
                isSignedIn: false,
            };
        }
        case actions.SIGN_OUT_SUCCESSFUL: {
            return {
                ...state,
                isSignedIn: false,
                backendVersion: null,
            };
        }
        case actions.STORE_USER_DATA: {
            return {
                ...state,
                user: response,
            };
        }
        case actions.UPDATE_USER_ICON: {
            const newUser = Object.assign({}, state.user);
            newUser.icon = response;
            return {
                ...state,
                user: newUser,
            };
        }
        case actions.STORE_USER_PERMISSIONS: {
            return {
                ...state,
                userPermissionList: response,
                userPermissionData: getPermissionData(response ?? []),
            };
        }
        case actions.REDIRECT_TO_WORKSPACE: {
            return {
                ...state,
                canRedirectToWorkspace: response,
            };
        }
        case actions.STORE_UI_COUNT_DATA: {
            return {
                ...state,
                uiCountMax: response.ui_count_max,
                uiCount: response.ui_count,
            };
        }
        case actions.STORE_BACKEND_VERSION: {
            return {
                ...state,
                backendVersion: response,
            };
        }
        case actions.STORE_AUTH_CHECK_PUBLIC_INFO: {
            return {
                ...state,
                authCheckPublicInfo: {
                    ...state.authCheckPublicInfo,
                    ...response,
                },
            };
        }
        default:
            return state;
    }
};
